import { Observable } from "rxjs";
import { PayloadApiResponse } from "./types.domain";
import { NotificationResponse } from "@portal-workspace/grow-shared-library";


export interface GetAllNotificationsEvent {
  type: 'getAllNotifications',
  notifications: Notification[]
}

export type GetAllNotificationsFn = (userId: number, originatorBusinessId: number) => Observable<PayloadApiResponse<NotificationResponse>>;
